/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time || time == '-') {
    return '-'
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    return value.toString().padStart(2, '0') || '-'
  })
  return time_str || '-'
}

export function theWeek(now) {
  var totalDays = 0;
  let years = now.getYear()
  if (years < 1000)
  years += 1900
  var days = new Array(12);
  days[0] = 31;
  days[2] = 31;
  days[3] = 30;
  days[4] = 31;
  days[5] = 30;
  days[6] = 31;
  days[7] = 31;
  days[8] = 30;
  days[9] = 31;
  days[10] = 30;
  days[11] = 31;
  //判断是否为闰年，针对2月的天数进行计算
  if (Math.round(now.getYear() / 4) == now.getYear() / 4) {
      days[1] = 29
  } else {
      days[1] = 28
  }
  if (now.getMonth() == 0) {
      totalDays = totalDays + now.getDate();
  } else {
    var curMonth = now.getMonth();
    for (var count = 1; count <= curMonth; count++) {
      totalDays = totalDays + days[count - 1];
    }
    totalDays = totalDays + now.getDate();
  }
  //得到第几周
  var week = Math.round(totalDays / 7);
  return week + 1;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    )
  }
}

export function hexToRgb(hex, opacity) {
  // 去除十六进制颜色值中的 # 符号
  hex = hex.replace('#', '');
 
  // 将十六进制颜色值转换为 RGB 格式
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
 
  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity / 100 + ')';
}

export function treeForeach (tree, func) {
  let node, list = [...tree]
  while (node = list.shift()) {
    func(node)
    node.children && list.push(...node.children)
  }
}

export function traverseTree(tree, key='level', val = 1) {
  for (const node of tree) {
    node[key] = val;
    if (!!node.children && node.children.length > 0) {
      node.children = node.children.sort(objArrayCompare)
      traverseTree(node.children, key, val + 1);
    }
  }
}

// 对象数组排序
export function objArrayCompare(obj1, obj2, attr = 'sort') {
  let val1 = obj1[attr];
  let val2 = obj2[attr];
  if (val1 < val2) {
    return -1;
  } else if (val1 > val2) {
    return 1;
  } else {
    return 0;
  }
}

export function findParent(tree, func, key= "", path = []) {
  if (!tree) return []
  for (const data of tree) {
    key=== "" ? path.push(data) : path.push(data[key]);
    if (func(data)) return path
    if (data.children && data.children.length) {
      const findChildren = findParent(data.children, func, key, path)
      if (findChildren.length) return findChildren
    }
    path.pop()
  }
  return []
}


export function findParentsById(data, targetId, result) {
  for (let item of data) {
    if (item.id === targetId) {
      //将查找到的目标数据加入结果数组中
      //可根据需求unshift(item.id)或unshift(item)
      result.unshift(item)
      return true
    }
    if (item.children && item.children.length > 0) {
      //根据查找到的结果往上找父级节点
      let isFind = findParentsById(item.children, targetId, result)
      if (isFind) {
        result.unshift(item)
        return true
      }
    }
  }
  //走到这说明没找到目标
  return false
}

// 树形结构扁平化
export function flatTreeData(tree) {
  const res = []
  function getData(tree) {
    tree.forEach(item => {
      res.push(item)
      if(item.children && item.children.length) {
        getData(item.children)
      }
    })
  }
  getData(tree)
  return res
}

// 判断是否是图片
export function isImage(fileName) {
	let suffix = `(jpg|png|jpeg)`
	const regular = new RegExp(`.*\.${suffix}`)
  return regular.test(fileName)
}

// 一维数组 转 二维数组
export function groupArr(arr, size) {
  var arr2 = [];
  for (var i = 0; i < arr.length; i = i + size) {
    arr2.push(arr.slice(i, i + size));
  }
  return arr2;
}

export function formatMoneyNumber(moneyNum) {

  if(typeof(moneyNum == "number")){
    moneyNum=moneyNum+"";
  }
  var moneyNum = moneyNum.replace(/,/g,"");
  //var result = isNaN(1 * moneyNum) ? new Number(0) : (1 * moneyNum);
  return /\./.test(moneyNum) ? moneyNum.replace(/(\d{1,3})(?=(\d{3})+\.)/g, "$1,") : moneyNum.replace(/(\d{1,3})(?=(\d{3})+\b)/g, "$1,");
}
